<template>
    <div v-if="match.sportType === '足球' && data1.matchTeamGameCount">
      <div class="score">
        <div>
          <p>{{ data1.matchTeamGameCount }}</p>
          <span>比赛场次</span>
        </div>
        <div>
          <p>{{ data1.matchTeamGoalCount }}</p>
          <span>进球数</span>
        </div>
      </div>
      <div class="vs bot">
        <div class="top">
          <img src="@/assets/images/match_record_left.png">
          <img src="@/assets/images/match_stats_02.png">
          <img src="@/assets/images/match_record_right.png">
          <div class="number" v-if="data1.avgMatchTeamGoalCount">
            <div class="left">{{ (data1.avgMatchTeamGoalCount).toFixed(1) }}</div>
            <div class="right">{{ data1.avgSysMatchGoalCount }}</div>
          </div>
        </div>
        <div class="bottom">
          <p style="padding-right: 20px; text-align: right;">本赛事</p>
          <p style="padding-left: 20px;">全平台赛事</p>
        </div>
      </div>
      <div class="more" @click="goStats">更多数据</div>
    </div>
</template>

<script>
export default {
  props: {
    data1: {
      typeof: Object,
      default: () => {}
    },
    match: {
      typeof: Object,
      default: {}
    },
  },
  methods: {
    goStats() {
      if (process.env.NODE_ENV === 'development') {
        window.location.href = `https://www.snsports.cn/webapp-stage/main.html#/match-stats?matchId=${this.match.id}`
      } else {
        window.location.href = `https://www.snsports.cn/webapp/main.html#/match-stats?matchId=${this.match.id}`
      }
    }
  }
};
</script>

<style scoped lang="scss">
.score{
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  div{
    font-size: 0;
    background-color: #fff;
    width: 49.8%;
    text-align: center;
    padding: 10px 0;
    p{
      font-size: 40px;
      margin-bottom: 5px;
    }
    span{
      font-size: 14px;
    }
  }
}
.vs{
      padding-top: 10px;
      background-color: #fff;
      .top{
        position: relative;
        display: flex;
        justify-content: center;
        img{
          height: 32px;
        }
        .number{
          font-size: 16px;
          color: #fff;
          font-weight: 500;
          width: 70%;
          height: 32px;
          position: absolute;
          display: flex;
          top: 0;
          div{
            box-sizing: border-box;
            width: 50%;
            height: 100%;
            line-height: 32px;
          }
          .left{
            text-align: right;
            padding-right: 28px;
          }
          .right{
            padding-left: 28px;
          }
        }
      }
      .bottom{
        display: flex;
        justify-content: center;
        padding-bottom: 10px;
        p{
          width: 30%;
          font-size: 14px;
          color: #ababab;
        }
      }
}
.bot{
  border-bottom: 2.5px solid #F8F8F8;
}
.more{
  padding: 10px 0;
  text-align: center;
  font-size: 14px;
  color: #ababab;
  background: #fff;
  margin-bottom: 20px;
}
p{
  margin: 0;
}
</style>
